<template>
<div :class="{ 'rounded bg-gray-100 mb-2' : showSelect }" class="specialty">
    <span v-if="emrSpec.checked && emrSpec.checked > 0" style="position:relative;">
        <i class="fal fa-check mr-2 text-green-600"></i>
        <div v-if="emrSpec.checked > 1" class="num-badge bg-primary rounded-circle text-xs font-white text-center font-weight-bold">{{ emrSpec.checked }}</div>
    </span>

    <span class="cursor-pointer" @click="showSelect ? setShowSelect(false) : setShowSelect(true)">
    	{{ emrSpec.label }}
    	<span class="text-gray-700">({{ emrSpec.SpecialtyCount }})</span>
    </span>

    <div v-if="showSelect" class="text-right w-auto pb-1">
        <select class="form-control form-control-sm mb-1" v-model="addToEmberSpecialty">
            <option value="" disabled selected>Map specialty to:</option>
            <option v-for="specialty in $store.state.options.specialties" :value="specialty.label">{{ specialty.label }}</option>
        </select>
        <span class="btn btn-sm btn-ghost-secondary" @click="cancelMap()">Cancel</span>
        <span class="btn btn-sm btn-primary" @click="addToMap()">Add to map</span>
    </div>
</div>
</template>

<script>
	import { mapState } from 'vuex';

	export default {
		props: [
			'emrSpec'
		],

		data() {
			return {
				showSelect: false,
				addToEmberSpecialty: null,
			}
		},

		methods: {
			addToMap() {
				//emit values
				this.$emit('add-mapping', { emberSpecLabel: this.addToEmberSpecialty, emrSpecLabel: this.emrSpec.label });
				this.addToEmberSpecialty = null;
				this.setShowSelect(false);
			},

			cancelMap() {
				this.setShowSelect(false);
			},

			setShowSelect(value) {
				this.showSelect = value;
			},
		},

		computed: {
			...mapState(['options']),
		}
	}
</script>

<style scoped>
	.num-badge { 
		width:11px;
		height:11px;
		position:absolute;
		line-height:11px;
		top:-3px;
		right:3px;
	}

	.specialty { 
		padding:.5rem .5rem .25rem .5rem;
		margin:0 -.5rem 0rem -.5rem;
	}
</style>